import React from "react";
import "./ScreenMessage.css";

const ScreenMessage = () => {
  const message =
    "We appreciate your visit, but we recommend using our website on PC or install our app from the app store for better experience";

  return (
    <div className="full-screen">
      <div className="screen-message-box">
        {message}
      </div>
    </div>
  )
};

export default ScreenMessage;
